const removeActiveButtons = (categoryButtons) => {
  categoryButtons.forEach(button => {
    button.classList.remove("active")
  })
}

const setActiveButton = (button) => {
  button.classList.add("active")
}

const fetchEventsInCategory = async (categoryId, eventList) => {
  const response = await axios.get("/local-events/get-local-events-in-category/" + categoryId)

  if (response?.data?.data) {
    eventList.innerHTML = response.data.data
  }
}

const addCategoryButtonEventListeners = (categoryButtons, eventList) => {
  (() => {
    if (categoryButtons[0]) {
      setActiveButton(categoryButtons[0])
    }
  })();

  categoryButtons.forEach((button) => {
    button.addEventListener("click", async (event) => {
      const BUTTON = event.target
      const CATEGORY_ID = BUTTON.dataset.id
      fetchEventsInCategory(CATEGORY_ID, eventList)
      removeActiveButtons(categoryButtons)
      setActiveButton(BUTTON)
    })
  })
}

const addCategorySelectEventListeners = (categorySelect, eventList) => {
  categorySelect.addEventListener("change", async () => {
    fetchEventsInCategory(categorySelect.value, eventList)
  })
}

window.addEventListener("load", () => {
  const EVENT_SECTIONS = document.querySelectorAll("section.local-events")

  EVENT_SECTIONS.forEach(eventSection => {
    const EVENT_LIST = eventSection.querySelector("#local-events-list")
    const CATEGORY_BUTTONS = eventSection.querySelectorAll("section.local-events button.category-btn")
    const CATEGORY_SELECT = eventSection.querySelector("select.category-select")
    addCategoryButtonEventListeners(CATEGORY_BUTTONS, EVENT_LIST)
    addCategorySelectEventListeners(CATEGORY_SELECT, EVENT_LIST)
  })
})
